"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageExports = exports.registerPackageExport = exports.linkedOntology = exports.linkedUtil = exports.linkedShape = exports.linkedComponent = void 0;
const Module_1 = require("lincd/lib/utils/Module");
_a = (0, Module_1.linkedPackage)('lincd-jsonld'), exports.linkedComponent = _a.linkedComponent, exports.linkedShape = _a.linkedShape, exports.linkedUtil = _a.linkedUtil, exports.linkedOntology = _a.linkedOntology, exports.registerPackageExport = _a.registerPackageExport, exports.packageExports = _a.packageExports;
